<template>
  <a-modal width="45%" :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
    :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose">
    <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
      <!--可编辑区域 start-->
      <div class="hidden">
        <a-form-item label="id" name="id">
          <a-input v-model:value="form.id" />
        </a-form-item>
      </div>
      <a-form-item label="公司名称" name="companyName">
        <a-input v-model:value="form.companyName" placeholder="请输入" />
      </a-form-item>
      <a-form-item label="所属行业" name="industry">
        <DictSelect v-model:value="form.industry" :dict-name="education.RESEARCH_FIELD" placeholder="请选择" />
      </a-form-item>
      <a-form-item label="职位名称" name="jobTitleName">
        <a-input v-model:value="form.jobTitleName" placeholder="请输入" />
      </a-form-item>
      <a-form-item label="在职时间" name="workTime">
        <range-picker style="width: 100%" v-model:startDate="form.timeEntry" v-model:endDate="form.timeDeparture" />
      </a-form-item>
      <a-form-item label="工作内容" name="contentWork">
        <a-textarea v-model:value="form.contentWork" placeholder="请输入" :auto-size="{ minRows: 4, maxRows: 6 }" />
      </a-form-item>
      <!--可编辑区域 end-->
    </a-form>
  </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import { formMixin } from "@/mixins";
import { workExpriseInfo } from "@/api/educationService";
import DictSelect from "@/components/other/DictSelect";
import { education, dateFormat } from "@/config/variableConfig";

export default {
  name: "UserModal",
  components: { DictSelect},
  mixins: [formMixin],
  data() {
    return {
      education,
      dateFormat,
      form: {
        id: null,
      },
      rules: {
        contentWork: [],
        industry: [],
        timeEntry: [],
        timeDeparture: [],
        jobTitleName: [dataCheck.required({})],
        companyName: [dataCheck.required({})],
        id: [],
      },
      submitUrl: workExpriseInfo.saveupdate
    }
  },
}
</script>
<style scoped lang="less"></style>
